module.exports = __webpack_public_path__ + "img/Arzypto-Dashboard.31a3669.svg";